import { Button, Tabs, TabsContent, TabsList, TabsTrigger } from "@dune/ui";
import { ArrowLeft } from "@untitled-ui/icons-react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetBinder } from "../../api/queries/binder.queries";
import BinderExclusions from "../../component/brokers/binders/BinderExclusions";
import BinderGeneralInfo from "../../component/brokers/binders/BinderGeneralInfo";
import BinderPricing from "../../component/brokers/binders/BinderPricing";
import BinderSubscriptionParams from "../../component/brokers/binders/BinderSubscriptionParams";
import BinderWarranties from "../../component/brokers/binders/BinderWarranties";

const BinderDetails = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const { data: binderData } = useGetBinder(id || "");

	if (!id) return null;
	if (!binderData) return null;

	const { binderAmendments, ...binderGeneralInfo } = binderData;
	const selectedBinderAmendment = binderData.binderAmendments[0];
	if (!selectedBinderAmendment) return null;

	return (
		<div className="flex flex-col justify-center p-6 gap-6">
			<div className="">
				<Button
					className="self-start text-[#144C65] px-0 has-[>svg]:px-0"
					variant="link"
					size="sm"
					onClick={() => navigate("/binders")}
				>
					<ArrowLeft /> Retour liste binders
				</Button>
				<h1 className="text-[#144C65] text-[32px] font-medium">
					{`${binderData.name} ${binderData.insurer?.society?.companyName}`}
				</h1>
			</div>
			<Tabs defaultValue="general-info" className="gap-6 w-full">
				<TabsList>
					<TabsTrigger value="general-info">Généralités</TabsTrigger>
					<TabsTrigger value="warranties">Tableau de garanties</TabsTrigger>
					<TabsTrigger value="subscription-params">
						Paramètres de souscription
					</TabsTrigger>
					<TabsTrigger value="pricing">Tarification</TabsTrigger>
					<TabsTrigger value="exclusions">Exclusions</TabsTrigger>
					<TabsTrigger value="documents" disabled>
						Documents
					</TabsTrigger>
				</TabsList>
				<TabsContent value="general-info">
					<BinderGeneralInfo
						binderData={binderGeneralInfo}
						binderAmendment={selectedBinderAmendment}
					/>
				</TabsContent>
				<TabsContent value="warranties">
					<BinderWarranties binderAmendment={selectedBinderAmendment} />
				</TabsContent>
				<TabsContent value="subscription-params">
					<BinderSubscriptionParams binderAmendment={selectedBinderAmendment} />
				</TabsContent>
				<TabsContent value="pricing">
					<BinderPricing binderAmendment={selectedBinderAmendment} />
				</TabsContent>
				<TabsContent value="exclusions">
					<BinderExclusions binderAmendment={selectedBinderAmendment} />
				</TabsContent>
			</Tabs>
		</div>
	);
};

export default BinderDetails;
